import React, { useState, useEffect, useCallback } from "react";
import http from "../utils/http-common";

const STORAGE_KEY = "inoqare_admin_wip_banner_dismissed";

function readFlag(data) {
  const v = data && data.show_site_wip_banner;
  return v === true || v === "true" || v === 1 || v === "1";
}

/**
 * Admin shell notice — same flag as public site (`show_site_wip_banner` via GET /settings/public).
 */
const WorkInProgressBanner = () => {
  const [flagOn, setFlagOn] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      setDismissed(sessionStorage.getItem(STORAGE_KEY) === "1");
    } catch {
      setDismissed(false);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    http
      .get("/api/v1/settings/public")
      .then((res) => {
        if (cancelled) return;
        setFlagOn(readFlag(res.data?.data));
      })
      .catch(() => {
        if (cancelled) return;
        setFlagOn(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const dismiss = useCallback(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore */
    }
    setDismissed(true);
  }, []);

  if (flagOn !== true || dismissed) return null;

  const contactEmail =
    (typeof process !== "undefined" && process.env.REACT_APP_CONTACT_EMAIL) || "contact@inoqare.com";

  return (
    <div
      className="alert alert-warning rounded-0 border-0 mb-0 py-2 px-3"
      role="region"
      aria-label="Site notice"
      style={{
        position: "relative",
        zIndex: 1,
        borderBottom: "1px solid #ffc107",
      }}
    >
      <div className="container-fluid d-flex flex-wrap align-items-start justify-content-between pr-5">
        <div className="pr-2">
          <strong className="d-block">Work in progress</strong>
          <span className="small text-dark">
            This admin area is under active development. You may encounter bugs — please{" "}
            <a href={`mailto:${contactEmail}?subject=Inoqare%20admin%20feedback`} className="font-weight-bold">
              report them
            </a>
            . A stable release is coming soon.
          </span>
        </div>
        <button
          type="button"
          className="close position-absolute"
          style={{ right: 12, top: 8 }}
          onClick={dismiss}
          aria-label="Dismiss notice"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  );
};

export default WorkInProgressBanner;
